import {
  AboutPage,
  ContentPage,
  FeedPage,
  HomePage,
  LoadingPage,
  ProjectPage,
} from "@/features";
import { basename } from "path";
import { createHashRouter } from "react-router-dom";

const router = createHashRouter([
  {
    path: "/",
    element: <HomePage />,
    children: [
      {
        path: "feed",
        
        element: <FeedPage />,
      },
      {
        path: "about",
        element: <AboutPage />,
      },
      {
        path: "content",
        element: <ContentPage />,
      },
      {
        path: "projects",
        element: <ProjectPage />,
      },
    ],
  },
]);

export default router;
